<template>
  <div class="lad-itinerary-section--paginate big-paginate">
    <el-button type="text" @click="changeTotal">{{
      $t(`${base}.show_more_days`)
    }}</el-button>

    <div class="more-days--wrapper">
      <span class="arrow-right"></span>
      <span class="more-days">+{{ daysNumber }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadItineraryPaginate',
  props: {
    daysNumber: { type: Number, required: true },
  },
  data() {
    return {
      base: 'components.itinerary.section',
    }
  },
  methods: {
    changeTotal() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss">
.lad-itinerary-section--paginate {
  background-color: #f9f9f9;
  position: relative;
  text-align: center;

  .more-days--wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #e2e2e2;
    display: table;

    & > * {
      display: table-cell;
      vertical-align: middle;
    }

    .more-days {
      padding: 0 0.8em;
      font-size: 0.9em;
    }
  }

  .arrow-right {
    border-top-width: 18px;
    border-bottom-width: 18px;
    border-left-width: 15px;
    border-left-color: #f9f9f9;
  }

  &.big-paginate {
    .el-button {
      font-size: 16px;
      text-transform: uppercase;
      font-weight: bold;
      line-height: 28px;
    }

    .arrow-right {
      border-top-width: 26px;
      border-bottom-width: 25px;
      border-left-width: 26px;
    }

    .more-days {
      font-size: 1em;
    }
  }
}
</style>
